var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6CDB98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6186 7.18757L8.34206 14.0542C7.93689 14.438 7.29903 14.4271 6.90725 14.0296L4.47524 11.574C4.21041 11.3153 4.10569 10.9339 4.20129 10.5762C4.2969 10.2186 4.57796 9.94025 4.93655 9.8482C5.29514 9.75614 5.67551 9.86463 5.93158 10.132L7.6554 11.8743L14.2094 5.69741C14.4756 5.44568 14.8559 5.35509 15.207 5.45975C15.5581 5.56441 15.8267 5.84844 15.9116 6.20483C15.9965 6.56122 15.8848 6.93584 15.6186 7.18757Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.3c52a13f306ee37adc6808b3f09b889e.svg";
export { ForwardRef as ReactComponent };